import Swiper, { Navigation, Pagination } from 'swiper'
Swiper.use([Navigation, Pagination]);

import $ from 'jquery'

import { isDesktop, isMobile, isTablet } from '../functions/check-viewport'



const container = document.querySelector('.pageLoc');


function toggleLoop(swiper, button, numDesk, numMobile) {

  const media = () => {
    if(isDesktop() || isTablet()) {
      return numDesk;
    }

    if (isMobile) {
      return numMobile;
    }
  }

  if (swiper.slides.length <= media()) {
    swiper.loopDestroy();
    button.classList.add('swiper-button-disabled');
    swiper.update();
  } else {
    swiper.update();
  }
}

if (container) {

  (function () {

    const cont = document.querySelectorAll('.PageLoc__swiper--ratting');

    cont.forEach(item => {
      const swiperRating = item.querySelector('.js-rating-swiper-rp');
      const swiperRatingButton = item.querySelector('.about-ratings__swiper-next--rp');


      const swiper = new Swiper(swiperRating, {
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 20,
        speed: 1e3,
        loop: true,
        breakpoints: { 640: { slidesPerView: 3, slidesPerGroup: 3, spaceBetween: 20 } },


        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: { nextEl: swiperRatingButton },

      });

      toggleLoop(swiper, swiperRatingButton, 9, 6)

    })
  })();


  (function () {


    const cont = document.querySelectorAll('.PageLoc__swiper--service');

    cont.forEach(item => {
      const swiperRating = item.querySelector('.js-services-swiper--rp');
      const swiperRatingButton = item.querySelector('.about-ratings__swiper-next--rp');


      const swiper = new Swiper(swiperRating, {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 20,
        speed: 1e3,
        loop: true,
        breakpoints: { 640: { slidesPerView: 2, slidesPerGroup: 2, spaceBetween: 20 } },


        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: { nextEl: swiperRatingButton },
      });

      toggleLoop(swiper, swiperRatingButton, 6, 3)

    })
  })();


  (function () {


    const cont = document.querySelectorAll('.PageLoc__swiper--projects');

    cont.forEach(item => {
      const swiperRating = item.querySelector('.js-projects-swiper--rp');
      const swiperRatingButton = item.querySelector('.about-ratings__swiper-next--rp');


      const swiper = new Swiper(swiperRating, {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 20,
        speed: 1e3,
        loop: true,
        breakpoints: { 640: { slidesPerView: 3, slidesPerGroup: 3, spaceBetween: 20 } },


        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: { nextEl: swiperRatingButton },
      });

      toggleLoop(swiper, swiperRatingButton, 9, 3)

    })
  })();


  (function () {


    const cont = document.querySelectorAll('.PageLoc__swiper--digest');

    cont.forEach(item => {
      const swiperRating = item.querySelector('.js-digest-swiper--rp');
      const swiperRatingButton = item.querySelector('.about-ratings__swiper-next--rp');


      const swiper = new Swiper(swiperRating, {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 20,
        speed: 1e3,
        loop: true,
        breakpoints: { 640: { slidesPerView: 2, slidesPerGroup: 2, spaceBetween: 60 } },


        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: { nextEl: swiperRatingButton },
      });

      toggleLoop(swiper, swiperRatingButton, 6, 3)

    })
  })();










}


(function () {


  const container = document.querySelector('.pageOffice');

  function addClass(item) {
    item.find('.itemC__inner').addClass('active');
    item.find('.itemC__title').addClass('active');
    item.find('.itemC__col').addClass('active');
    item.find('.btn-round').addClass('active');
  }

  function removeClass(item) {
    item.find('.itemC__inner').removeClass('active');
    item.find('.itemC__title').removeClass('active');
    item.find('.itemC__col').removeClass('active');
    item.find('.btn-round').removeClass('active');
  }

  if (container) {



    const item1 = $('.itemC--1');
    const item2 = $('.itemC--2');
    const item3 = $('.itemC--3');
    const item4 = $('.itemC--4');

    if (isDesktop()) {
      ItemOne();
      ItemTwo();
      ItemThree();
      ItemFour();
      clickButton();
    }

    if (isTablet() || isMobile()) {
      ItemOneTablet();
      ItemTwoTablet();
      ItemThreeTablet();
      ItemFourTablet();
    }

    function clickButton() {
      const container = document.querySelector('.pageOffice__inner--desk');
      const items = container.querySelectorAll('.itemC');

      items.forEach(item => {
        item.addEventListener('click', el => {
          const link = item.querySelector('.rp__contacts-item--link');
          console.log(link);
          link.click();
        })
      })
    }



    function addClassMain(th,item, class1, class2, class3) {
      th.addClass(item)
      class1.addClass(item)
      class2.addClass(item)
      class3.addClass(item)
    }

    function addClassMainTablet(th,item, class1, class2, class3) {
      th.addClass(item)
      class1.addClass(item)
      class2.addClass(item)
      class3.addClass(item)
    }

    function removeClassMain(th,item, class1, class2, class3) {
      th.removeClass(item)
      class1.removeClass(item)
      class2.removeClass(item)
      class3.removeClass(item)
    }

    $(document).mouseup( function(e){
      var div = item1;
      if ( !div.is(e.target)
          && div.has(e.target).length === 0 ) {
            removeClassMain(item1,'active--1', item2, item3, item4)
            removeClass(item1)
      }
    });

    $(document).mouseup( function(e){
      var div = item2;
      if ( !div.is(e.target)
          && div.has(e.target).length === 0 ) {
            removeClassMain(item2,'active--2', item1, item3, item4)
            removeClass(item2)
      }
    });

    $(document).mouseup( function(e){
      var div = item3;
      if ( !div.is(e.target)
          && div.has(e.target).length === 0 ) {
            removeClassMain($(this),'active--3', item1, item2, item4)
            removeClass($(this))
      }
    });

    $(document).mouseup( function(e){
      var div = item4;
      if ( !div.is(e.target)
          && div.has(e.target).length === 0 ) {
            removeClassMain($(this),'active--4', item1, item2, item3)
            removeClass($(this))
      }
    });

    function ItemOne() {
      item1
      .on('mouseenter', function() {
        addClassMain($(this),'active--1', item2, item3, item4)
        addClass($(this))


      })
      .on('mouseleave', function() {
        removeClassMain($(this),'active--1', item2, item3, item4)
        removeClass($(this))


      })
    }

    function ItemOneTablet() {
      item1
      .on('click', function(e) {
        addClassMain($(this),'active--1', item2, item3, item4)
        addClass($(this))
      })
    }



    function ItemTwo() {
      item2
      .on('mouseenter', function(e) {
        addClassMain($(this),'active--2', item1, item3, item4)
        addClass($(this))


      })
      .on('mouseleave', function() {
        removeClassMain($(this),'active--2', item1, item3, item4)
        removeClass($(this))
      })
    }

    function ItemTwoTablet() {
      item2
      .on('click', function() {
        addClassMain($(this),'active--2', item1, item3, item4)
        addClass($(this))
      })
    }




    function ItemThree() {
      item3
      .on('mouseenter', function() {
        addClassMain($(this),'active--3', item1, item2, item4)
        addClass($(this))


      })
      .on('mouseleave', function() {
        removeClassMain($(this),'active--3', item1, item2, item4)
        removeClass($(this))

      })
    }

    function ItemThreeTablet() {
      item3
      .on('click', function() {
        addClassMain($(this),'active--3', item1, item2, item4)
        addClass($(this))
      })

    }


    function ItemFour() {
      item4
      .on('mouseenter', function() {
        addClassMain($(this),'active--4', item1, item2, item3)
        addClass($(this))



      })
      .on('mouseleave', function() {
        removeClassMain($(this),'active--4', item1, item2, item3)
        removeClass($(this))

      })
    }

    function ItemFourTablet() {
      item4
      .on('click', function() {
        addClassMain($(this),'active--4', item1, item2, item3)
        addClass($(this))



      })
    }









  }

  const containerMobile = document.querySelector('.pageOffice__inner--mobile');

  if (containerMobile) {


    (function AccordionFilters() {
      const cont = document.querySelector('.pageOffice__inner--mobile');
      const accordions = cont.querySelectorAll('.itemC');
      const buttonAll = cont.querySelectorAll('.itemC__title');
      const menuAll = cont.querySelectorAll('.itemC__menu');
      const fonAll = cont.querySelectorAll('.itemC__fon');

      menuAll.forEach(item => {
        item.addEventListener('click', el => {
          if (item.classList.contains('open')) {
            const link = item.querySelector('a');
            link.click();
          }
        })
      })

      if (accordions) {
        accordions.forEach(el => {
          const button = el;

          button.addEventListener('click', e => {
            dropdown(accordions, menuAll, fonAll, buttonAll);
            let self = e.currentTarget;
            const content = self.querySelector('.itemC__menu');
            const fon = self.querySelector('.itemC__fon');
            const button = self.querySelector('.itemC__title');
            self.classList.toggle('open')
            fon.classList.toggle('open')
            button.classList.toggle('open');
            content.classList.toggle('open');


            if (self.classList.contains('open')) {
              content.style.maxHeight = content.scrollHeight + 'px';
            } else {
              content.style.maxHeight = null;
            }
          });
        });




        function dropdown(accordions, content, fon, btns) {
          for (let i = 0; i < accordions.length; i++) {
            accordions[i].addEventListener("click", function () {
              for (var j = 0; j < accordions.length; j++) {
                if (i != j) {
                  content[j].classList.remove("open");
                  accordions[j].classList.remove("open");
                  fon[j].classList.remove("open");
                  btns[j].classList.remove("open");
                  content[j].style.maxHeight = null;
                }
              }
            });
          }
        }
      }
    })();
  }





})()

